module.exports = __webpack_public_path__ + "img/01.c5c5cf32.jpg";